import styled from 'styled-components';
import spinnerImage from '../static/images/loading-icon.svg';

export const Spinner = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: white url(${spinnerImage}) center center no-repeat;
	background-size: 50px;
	opacity: 0.7;
	z-index: 1000;
`;
